import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect,useState } from 'react';
import { _postURL } from '@/api/index';
import Redux, { updatePath } from "@/action";
import _ from 'lodash';
import { TyreBrands } from '@/components/tyre/brands';
import { TyreModel } from '@/components/tyre/model';
import { TyreWriteReview } from '@/components/tyre/writeReview';
import { TyreReview } from '@/components/tyre/review';
import { TyreFilter } from '@/components/tyre/filter';
import { TyreFilterResult } from '@/components/tyre/filterResult';
import { useRouter } from 'next/router';
import { pageLink } from '@/config/site';
import { getCookies, hasCookie } from 'cookies-next';

export default function Index(props) {
    const { store, dispatch } = Redux();
    const { t, device, session, params, fetchedData } = props;
    const [loading, setLoading] = useState(false);
    const router = useRouter()

    if( // model review page
        params?.tyre?.length === 3
        && params?.tyre?.[0] != "filter" 
        && params?.tyre?.[1] != "result" 
        && params?.tyre?.[2] == "review" 
        && params?.tyre?.[2] != "write-review"
        && !_.isEmpty(fetchedData)
    ){
        return <TyreReview {...props} />
    } else if(  // write review page
        params?.tyre?.length === 3
        && params?.tyre?.[0] != "filter" 
        && params?.tyre?.[1] != "result" 
        && params?.tyre?.[2] == "write-review"
        && !_.isEmpty(fetchedData)
    ){
        return <TyreWriteReview {...props} />
    } else if( // filter result page
        params?.tyre?.length === 2
        && params?.tyre?.[0] == "filter" 
        && params?.tyre?.[1] == "result" 
        && !_.isEmpty(fetchedData)
    ){
        return <TyreFilterResult {...props} />
    } else if( // model detail page
        params?.tyre?.length === 2
        && params?.tyre?.[0] != "filter" 
        && params?.tyre?.[1] != "result"
        && !_.isEmpty(fetchedData)
    ){
        return <TyreModel {...props} />
    } else if( // filter page
        params?.tyre?.length === 1
        && params?.tyre?.[0] == "filter" 
    ){
        return <TyreFilter {...props} />
    } else if( // brand page
        params?.tyre?.length === 1
        && params?.tyre?.[0] != "filter" 
        && !_.isEmpty(fetchedData)
    ){
        return <TyreBrands {...props} />
    } else {
        return <>404 page</>
    }

}

export async function getServerSideProps ({ req, res, locale, params, query }) {

    try {
        let fetchedData = null;
        if(  // model review page
            params?.tyre?.length === 3
            && params?.tyre?.[0] != "filter" 
            && params?.tyre?.[1] != "result" 
            && params?.tyre?.[2] == "review" 
            && params?.tyre?.[2] != "write-review"
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/tyre/getModelDetail`, { brand_custom_url: params?.tyre[0], model_custom_url: params?.tyre[1] })
            ]);
            fetchedData = data ?? {}
        } else if(  // write review page
            params?.tyre?.length === 3
            && params?.tyre?.[0] != "filter" 
            && params?.tyre?.[1] != "result" 
            && params?.tyre?.[2] == "write-review"
        ){
            if(_.isEmpty(getCookies({ req, res })?.user)){
                // if no login throw error
                throw new Error()
            }
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/tyre/getModelDetail`, { brand_custom_url: params?.tyre[0], model_custom_url: params?.tyre[1] })
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.tyre?.length === 2
            && params?.tyre?.[0] == "filter" 
            && params?.tyre?.[1] == "result" 
        ){
            fetchedData = {}
            var queryLength = Object.keys(query).length;
            var request = queryLength == 1 ? {} : query;    // check query string, if have query string, then use query string, else pass empty for all result
            const [
                { value: { data: filterResult } },
                { value: { data: vehicleModelList } }
            ] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/tyre/getFilterResultData`, request),
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getAllModelList`, {})
            ]);
            fetchedData = {filterResult, vehicleModelList, request} ?? {}
        } else if( // model detail page
            params?.tyre?.length === 2
            && params?.tyre?.[0] != "filter" 
            && params?.tyre?.[1] != "result"
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/tyre/getModelDetail`, { brand_custom_url: params?.tyre[0], model_custom_url: params?.tyre[1] })
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.tyre?.length === 1
            && params?.tyre?.[0] == "filter" 
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/tyre/getFilterInitialData`)
            ]);
            fetchedData = data ?? {}
        } else if( // brand page
            params?.tyre?.length === 1
            && params?.tyre?.[0] != "filter" 
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/tyre/getBrandDetail`, { brand_custom_url: params?.tyre[0] })
            ]);
            fetchedData = data ?? {}
        } else {
            throw new Error();
        }

        if (_.isEmpty(fetchedData) && params?.tyre?.[0] != "filter" ) throw new Error();

        return {
            props: {
                ...(await serverSideTranslations(locale, ['common'])),
                fetchedData,
                params,
                query
            },
        };
    } catch (error) {
        return {
            notFound: true,
        }
    }
}